/**
 * Its a wrapper around the host app related information like host app name, content language, display language etc.
 */
export class HostAppUtil {

    //Returns the current host app name like WORD/ONENOTE etc.
    public static GetHostAppName(): string {
      return Office.context.diagnostics.host.toString().toUpperCase();
    }

    //Returns host app's content/editing language set by the user.
    public static GetHostAppContentLaguage(): string {
      return Office.context.contentLanguage;
    }

    //Returns host app's display language set by the user.
    public static GetHostAppDisplayLanguage(): string {
      return Office.context.displayLanguage;
    }

    //Returns host app's platform.
    public static GetHostAppPlatform(): string {
      return Office.context.diagnostics.platform.toString().toUpperCase();
    }

}